import * as Yup from 'yup';
import { Tender } from '../../../../../shared/types/tender';

export const initialValues: Tender = {
    projectId: '',
    startProcessDate: null,
    clientEntity: '',
    accountManager: '',
    otherAccountManager: '',
    crm: '',
    architectureManager: '',
    otherArchitectureManager: '',
    processType: '',
    deliveryMethod: '',
    statusProcess: '',
    bidder: '',
    nit: '',
    observations: '',
    accountManagerEmail: '',
    architectureManagerEmail: '',
};

export const validationSchema = (
    otherAccountManagerId: string,
    otherArchitectureManagerId: string
) =>
    Yup.object({
        startProcessDate: Yup.date()
            .typeError('Debe ingresar una fecha válida')
            .required('La fecha de inicio es obligatoria'),
        clientEntity: Yup.string().required(
            'La entidad cliente es obligatoria'
        ),
        accountManager: Yup.string().required(
            'El gerente de cuenta es obligatorio'
        ),

        otherAccountManager: Yup.string().when('accountManager', {
            is: (val: string) => val === otherAccountManagerId,
            then: (schema) =>
                schema.required('El nombre del gerente es requerido'),
            otherwise: (schema) => schema.notRequired(),
        }),

        crm: Yup.string().required('El código CRM es obligatorio'),
        architectureManager: Yup.string().required(
            'El gerente de arquitectura es obligatorio'
        ),

        otherArchitectureManager: Yup.string().when('architectureManager', {
            is: (val: string) => val === otherArchitectureManagerId,
            then: (schema) =>
                schema.required(
                    'El nombre del gerente de arquitectura es requerido'
                ),
            otherwise: (schema) => schema.notRequired(),
        }),

        processType: Yup.string().required('El tipo de proceso es obligatorio'),
        deliveryMethod: Yup.string().required(
            'El método de entrega es obligatorio'
        ),
        bidder: Yup.string().required('El proponente es obligatorio'),
        nit: Yup.string().nullable(),

        accountManagerEmail: Yup.string()
            .email('Debe ser un correo valido')
            .required('El correo del gerente de cuenta es obligatorio'),

        architectureManagerEmail: Yup.string()
            .email('Debe ser un correo valido')
            .required('El correo del gerente de arquitectura es obligatorio'),

        projectId: Yup.string().required('El proyecto es necesario'),
    });
